import t from "@ext/localization/locale/translate";
import { ConfirmPopover } from "@ui-kit/ConfirmPopover";
import { DeleteSelectedButton } from "./DeleteSelectedButton";

interface DeleteSelectedConfirmProps {
	onConfirm: () => Promise<unknown>;
	selectedCount: number;
}

export const selectedRecordsDeleteBody = (count: number) =>
	t("confirmation.delete.body")
		.replace("{count}", count.toString())
		.replace("{item}", count === 1 ? t("record") : t("records"));

export const DeleteSelectedConfirm = ({ onConfirm, selectedCount }: DeleteSelectedConfirmProps) => {
	if (!selectedCount) return null;

	return (
		<ConfirmPopover
			confirmText={t("delete")}
			description={selectedRecordsDeleteBody(selectedCount)}
			icon="info"
			onConfirm={onConfirm}
			status="error"
			title={t("confirmation.delete.title")}
		>
			<DeleteSelectedButton count={selectedCount} />
		</ConfirmPopover>
	);
};
